<div [class.cm-square-container]="$squareFormat()" [class.cm-default-container]="!$squareFormat()">
    <div class="cm-file-add">
        <i class="far fa-plus"></i>
        <ng-content select="[cm-text]"></ng-content>
    </div>
</div>
